import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
export const Placeholder = ({ style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(View, { style: styles.wrapper },
            React.createElement(View, { style: styles.image }),
            React.createElement(View, { style: styles.name }),
            React.createElement(View, { style: styles.type }))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    fluid: { flex: 1 },
    container: {
        backgroundColor: color.invert2.p4,
        paddingHorizontal: size.G,
        paddingVertical: size.L,
        borderRadius: size.G,
        alignItems: 'center',
        borderColor: color.invert2.p4
    },
    wrapper: {
        width: 120,
        alignItems: 'center'
    },
    image: {
        height: 62,
        width: 62,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    name: {
        width: 52,
        height: size.F,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginTop: size.D + (size.H - size.F) / 2,
        marginBottom: (size.H - size.F) / 2
    },
    type: {
        width: 84,
        height: size.F,
        borderRadius: size.B,
        backgroundColor: color.invert2.p4,
        marginTop: (size.I - size.F) / 2,
        marginBottom: (size.I - size.F) / 2
    }
}));
//# sourceMappingURL=Placeholder.js.map